import React, { useContext, useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { AppContext } from "../../Resources/CanvasContextFile";
import home_blue from "../../Icons/home_blue.svg";
import Cross from "../../Icons/Cross";
import threedots_x_SVG from "../../Icons/threedots_x.svg";
import Duplicate from "../../Icons/Duplicate.svg";
import Home from "../../Icons/Home.svg";
import Rename from "../../Icons/Rename.svg";
import Preview from "../../Icons/Preview.svg";
import Delete from "../../Icons/Delete.svg";
import axios from "../../axios";
import { CircularProgress } from "@material-ui/core";
import { addIdsFromJsonToExistingIDs, getFormId, setCurrentDataObjectsContent } from "../IFormDesignerLayout/IFormDesignerLogic";
import DOMPurify from "dompurify";
import { useSelector } from "../../Redux";
import CreatePageTemplate from "../LeftNavigation/PageTemplate/CreatePageTemplate";
import SearchControl from "../LeftNavigation/GlobalSearch/SearchControl";
import SearchBox from "../../ReusableComponents/SearchBox";
import CustomizedAlert from "../../ReusableComponents/Alert/CustomizedAlert";
import { useTranslation } from "react-i18next";
import { func } from "prop-types";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { defaultBuffer } from "../../Resources/defaultBuffer";
import { useLayoutEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { GetStateFromData, GetState } from "../CustomHooks/CustomHooks";
import secureLocalStorage from "react-secure-storage";
import SubformTooltip from "./SubformTooltip";
import secureSessionStorage from "../../utils/secureSessionStorage";

const useStyles = makeStyles((topYcordinate, matchesTablet) => ({
  main: {
    position: "absolute",
    zIndex: "999",
    left: "-68px",
    width: "300px",
    height: (topYcordinate) => `calc(100vh - ${topYcordinate}px)`,
    background: "#fff",
    border: "1px solid #00000020",
    "& hr": {
      height: "0",
      width: "90%",
      margin: "10px auto"
    }
    // '& *':{
    //     fontSize: matchesTablet => matchesTablet ? "12px" : "8px"
    // }
  },
  mainHeader: {
    fontSize: "16px",
    fontWeight: "600",
    // height:"2em",
    padding: "8px 10px",
    display: "flex",
    justifyContent: "flex-end"
  },
  header: {
    fontSize: "14px",
    fontWeight: "600",
    // height:"2em",
    padding: "12px 10px",
    display: "flex",
    textAlign: "left",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    justifyContent: "space-between"
  },
  plusButton: {
    color: "#0072C6",
    fontWeight: "900",
    transform: "scale(2)",
    cursor: "pointer"
  },
  plusButtonDisabled: {
    color: "#0072C6",
    fontWeight: "900",
    transform: "scale(2)",
    cursor: "not-allowed"
  },
  btn1: {
    width: "94px",
    height: "23px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #0072C6",
    borderRadius: "2px",
    opacity: 1,
    // padding: "5px 8px 6px 8px",
    marginRight: "5px",
    marginLeft: "5px",
    cursor: "pointer"
  },
  btn2: {
    width: "118px",
    height: "23px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #0072C6",
    borderRadius: "2px",
    opacity: 1,
    // padding: "5px 8px 6px 8px",
    marginRight: "5px",
    marginLeft: "5px",
    cursor: "pointer"
  },
  btnlabel: {
    textTransform: "none",
    font: "normal normal 600 12px/12px Open Sans",
    color: "#0072C6",
    cursor: "pointer"
  },

  allPages: {
    // maxHeight: "40vh",
    maxHeight: `calc( 100% - 70px )`,
    height: `calc( 100% - 70px )`,
    overflow: "auto",
    // display:"flex",
    // justifyContent:"space-between"
    "& input": {
      height: "2em"
    }
  },
  pages: {
    fontSize: "14px",
    height: "3em",
    padding: "10px 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // boxShadow: "0px 3px 6px #0000000D",
    textAlign: "left",
    font: "normal normal normal 14px/16px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    "& img": {
      height: "12px"
    },
    "&:hover": {
      // boxShadow: "0px 3px 6px #00000029"
      background: "#eaeaea"
    },
    cursor: "pointer"
  },
  activePage: {
    fontSize: "14px",
    height: "3em",
    padding: "10px 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#1071C519",
    // boxShadow: "0px 3px 6px #0000000D",
    // background:"#1071C519",
    textAlign: "left",
    font: "normal normal normal 14px/16px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    "& img": {
      height: "12px"
    },
    cursor: "pointer"
  },
  fonts: {
    textAlign: "left",
    font: "normal normal normal 14px/16px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1
  },
  popUp: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    // right:"0",
    zIndex: "999",
    // border:"1px solid #fff",
    // boxShadow: "0px 3px 6px #00000029",
    borderRadius: "3px",
    fontSize: "12px",
    width: "120px",
    "& span": {
      cursor: "pointer",
      height: "28px",
      background: "#fff",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        background: "#cde7fe"
      }
    },
    "& img": {
      margin: "0 10px",
      height: "16px",
      width: "16px"
    }
  },
  search: {
    margin: "5px 10px",
    boxShadow: "0px 3px 6px #00000029"
  }
}));

function PagesSubForms(props) {
  const matchesTablet = useMediaQuery("(min-width:1000px)");

  console.log("matchesTablet", matchesTablet);

  const translationStyles1 = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;
  const contexts = GetStateFromData(props.containerId);

  const {resetUndoList , resetRedoList} = props;

  const {
    updateJson,
    activePage,
    setActivePage,
    activeSubForm,
    setActiveSubForm,
    microFrontendData,
    activeApplication,
    allPages,
    setAllPages,
    handleSubForm,
    openCanvasForSubform,
    setShowSubForm,
    showSubform,
    //allSubForms, setSubForms, setShowPagesSubForms,setFormState2 ,setQuickToolsClose,setActiveApplication }=contexts.contexts;
    allSubForms,
    setSubForms,
    setShowPagesSubForms,
    setFormState2,
    setActiveApplication,
    setApplicationData,
    onDragOfSubform,
    onDragStartOfSubform,
    latestChangesSaved,
    setLatestChangesSaved,
    dataObjectsContent,
    setDataObjectsContent,
    setSelectedControl,
    setCurrentMappedDO,
    setfilteredDataObject,
    setIsStep,
    formState2,
    eventList,
    setEventList,
    setfilteredDataObjectCopy,
    setPropertyPinned,
    showAlertConfirmNotifications,
    setGlobalLoading,
    setGlobalLoadingMessage,
    setActiveMenuId,
    setHomePage,
  } = contexts.contexts;

  const { saveFormState } = updateJson;

  const currElem = document.querySelector("#PagesSubforms_id");
  const topYcordinate = currElem?.getBoundingClientRect()?.top;

  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
});
  const [page, setPage] = useState();
  const [subform, setSubForm] = useState();
  const [navigateToPageType, setNavigateToPageType] = useState();

  const marvinContexts = GetStateFromData(props?.containerId, "marvinData");
  const { renamePageSubform } = marvinContexts.marvinStates;
  //  console.log("topYcordinate",topYcordinate);

  const { t } = useTranslation();

  const classes = useStyles(topYcordinate, matchesTablet);
  // const { activePage, setActivePage, activeSubForm, setActiveSubForm, activeApplication, allPages, setAllPages,
  //     allSubForms, setSubForms, setShowPagesSubForms,setFormState2 ,setQuickToolsClose,setActiveApplication } = useContext(AppContext);
  //  console.log(activeApplication);

  const [filteredPages, setFilteredPages] = useState(allPages);
  const [filteredSubforms, setFilteredSubforms] = useState(allSubForms);

  const [newPage, setNewPage] = useState({
    processDefId: 0,
    // formId:"",
    formName: `Page ${allPages.length + 1}`,
    formBuffer: JSON.stringify(defaultBuffer),
    isEncrypted: "N",
    lastModifiedOn: new Date(),
    deviceType: "A",
    formHeight: 400,
    formWidth: 400,
    existingFormId: "",
    formType: "P"
  });

  const [newSubForm, setNewSubForm] = useState({
    processDefId: 0,
    // fragmentId:"",
    fragmentName: `Subform ${allSubForms.length + 1}`,
    //fragmentBuffer:"",
    fragmentBuffer: JSON.stringify(defaultBuffer),
    isEncrypted: "N",
    structureName: "",
    structureId: -1,
    lastModifiedOn: new Date(),
    deviceType: "A",
    formHeight: 400,
    formWidth: 400,
    projectId: ""
  });

  const [addNewPageLoader, setAddNewPageLoader] = useState(false);
  const [pageTemplateOpen, setPageTemplateOpen] = useState(false);
  const [subformTemplateOpen, setSubformTemplateOpen] = useState(false);

  const [pageNameOld, setPageNameOld] = useState("");

  function handleClose() {
    setPageTemplateOpen(false);
  }

  const handleClickAway = (e) => {
    setShowPagesSubForms(false);
  //   window.callSpecifiedFunctions(
  //     { },
  //     "",
  //     "",
  //     true  
  // );
  };

  function handleSubformClose() {
    setSubformTemplateOpen(false);
  }
  const [countIncrementer, setCountIncrementer] = useState(0);
  useEffect(() => {}, []);
  // async function fetchingChildren(event, dataC, isParent) {
  //   let count = 0;
  //   //    async function fetchingChildren(data){
  //   // setSelectedDataObject(dataC)

  //   var treeName = "";

  //   if (dataC?.treeName) {
  //     treeName = dataC?.treeName;
  //   }

  //   // setChildVisiblity(!childVisible);
  //   // setShowMapButton(false);
  //   // console.log("childVisiblechildVisible ", childVisible);

  //   var ab = 1;

  //   // if(childVisible===false && ab === 0 )

  //   var currName = dataC.VariableName;
  //   var pName = dataC?.parentName ? dataC?.parentName + "." : "";

  //   // var parentname= pName + currName;

  //   var parentname = currName;

  //   var jsonToSend = { tableName: parentname, tableid: dataC.VariableId };
  //   // var jsonToSend={"tableName":data.VariableName,"tableid":data.VariableId,  "parentName": (currName+pName)};
  //   // var jsonToSend={"tableName":"SanityTable"};

  //   //   fetchTableChildren(jsonToSend).then((response)=>{
  //   //      console.log("data after expanding the data Object ", response.data["children"]);
  //   //     data.children=response.data["children"];
  //   //      setRenderInstant(data);
  //   // })

  //   // console.log("content.data content.data table def ",);

  //   fetch("/mdm-rest/app/gettabledefinition", {
  //     method: "post",
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //     body: JSON.stringify({
  //       id: dataC.VariableId,
  //       name: parentname,
  //       status: "1"
  //     })
  //   })
  //     .then(function (response) {
  //       return response.json();
  //     })
  //     .then(function (content) {
  //       // console.log("content.datacontent.datatable123 ", content);

  //       var data = JSON.stringify(content.data);
  //       let formId = getFormId();

  //       const jsonData = {
  //         formId: formId.toString() || activePage?.formId,
  //         data: `${data}`,
  //         treeName: treeName
  //       };

  //       axios
  //         .post("/idesign/gettableDefinition", jsonData, { withCredentials: true })
  //         .then(async (response) => {
  //           var childArray = [];

  //           dataC.children = response.data.children;
  //           const responses = response?.data?.["children"] ? response : [];
  //           const dataResponse = responses ? (responses?.data ? responses?.data : []) : [];
  //           const newDataResponse = dataResponse ? (dataResponse?.["children"] ? dataResponse["children"] : []) : [];

  //           if (newDataResponse) {
  //             for (let child of newDataResponse) {
  //               if (child?.MappingInfo) {
  //                 fetchingChildren("", child, newDataResponse.length, count);
  //               }
  //             }
  //           }
  //           if (isParent === true) {
  //             return true;
  //           }
  //           // console.log("content.datacontent.datatable123 ", dataC);
  //           // setRenderInstant(dataC);
  //         })
  //         .catch(function (error) {
  //           if (error.response) {
  //           }
  //           //   alert(error);
  //           console.log("error is", error);
  //         });
  //     })
  //     .catch((err) => {
  //       console.log("error is", err);
  //     });
  // }

  const fetchingAllDataObjects = async (dataC, isParent) => {
    window.loading(true)
    const parentname = dataC?.VariableName

    const jsonData = {
      parentTableId: dataC ? (dataC?.VariableId ? dataC?.VariableId : "") : "",
      treeName: parentname || "",
      status: "1",
      formId: getFormId().toString()
    }

    let finalDataObjects = await axios
    .post("/idesign/gettableDefinition", jsonData, {
      withCredentials: true,
    })
    .then((response) => {
      return response?.data || {}
    })
    .catch((error) => {
      console.log("error", error)
    })
    window.loading(false)
    return [finalDataObjects]
  }
  
  let countObj = {
    count: 0
  };
  function fetchDataObject(appId, formId) {
    fetch("/mdm-rest/app/dataobjects", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwtToken,
      },
      body: JSON.stringify({
        // "parent_id":'29104',
        // "parent_id": `${props.appId}`,
        // "parent_id": `${props.appId}`,
        parent_id: appId,
        type: "AP",
        sort_order: "A",
        order_by: "1",
        records_to_fetch: "30",
        mode: "tree"
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (content) {
        //console.log("content.data content.data ", content.data_objects);
        if (content.data.data_objects !== undefined) {
          var jsonDataSend = {
            data: content.data.data_objects
          };
          var data = JSON.stringify(content.data.data_objects);
          let formId = getFormId();
          const jsonData = {
            formId: formId || formId.toString(),
            data: `${data}`
          };
          axios
            .post("/idesign/getDataObjectsforMapping", jsonData, { withCredentials: true })
            .then(async (response) => {
              // setDataObjectsState(response.data);
              const responses = response?.data?.["children"] ? response : [];
              const dataResponse = responses ? (responses?.data ? responses?.data : []) : [];
              let newDataResponse = dataResponse ? (dataResponse?.["children"] ? dataResponse["children"] : []) : [];
               if(newDataResponse?.length > 1){
                      showAlertConfirmNotifications({
                        'open':true,
                        'showConfirm':'showNotification',
                        'alertType':'error',
                        'alertContentKey': "Only one parent table is allowed. Please define the parent-child relation with the system-generated parent table."
                      });
                    } else {
                      for (let child of newDataResponse) {
                        newDataResponse = await fetchingAllDataObjects(child, true);
                        setDataObjectsContent(newDataResponse);
                        setfilteredDataObject(newDataResponse);
                        setfilteredDataObjectCopy(newDataResponse);
                        setCurrentDataObjectsContent(newDataResponse);

                      }
                    }
              // setDataObjectsContent(newDataResponse);
              // setfilteredDataObject(newDataResponse);
              // setfilteredDataObjectCopy(newDataResponse);
              setTimeout(() => {
                setGlobalLoading(false);
              }, 2500);
              // setDataLoaded(true);
            })
            .catch(function (error) {
              if (error.response) {
              }
              console.log("error is", error);
              setGlobalLoading(false);
              // alert(error);
            });
        }
      })
      .catch((err) => {
        console.log("error is", err);
        setGlobalLoading(false);
      });
  }

  function getAllPages(forComponent) {
    let payload = { withCredentials: true };
    // if(forComponent==='subform'){
    //     payload[''] = 'subform';
    // }
    axios
      .get(`/interfaces/${activeApplication.applicationId}`)
      .then((res) => {
        setAllPages([...res.data]);
      })
      .catch(() => {
        console.log("ERROR ON LOADING PAGES OF APP ID ", activeApplication.applicationId);
      });
  }

  function getAllSubForms() {
    axios
      .get(`/widgets/${activeApplication.applicationId}`, { withCredentials: true })
      .then((res) => {
        setSubForms([...res.data]);
      })
      .catch(() => {
        console.log("ERROR ON LOADING PAGES OF APP ID ", activeApplication.applicationId);
      });
  }

  function openCreatePageTemplate() {
    // //  console.log("page..", pageTemplateOpen)
    setPageTemplateOpen(true);
  }

  function openCreateSubformTemplate() {
    setSubformTemplateOpen(true);
  }

  function addNewPage() {
    setAddNewPageLoader(true);
    //const newPageJson={...newPage,"existingFormId": activeApplication.applicationId};

    const newPageJson = { ...newPage, existingFormId: activeApplication.applicationId };

    if (!addNewPageLoader) {
      axios
        .post("/interfaces/", newPageJson, { withCredentials: true })
        .then((res) => {
          setAddNewPageLoader(false);
          //  console.log("NOT ERROR ON adding new pages ");
          getAllPages();
        })
        .catch((err) => {
          setAddNewPageLoader(false);
          const errMessage = err.response.data.error;
          let errorMessage;
          if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
          else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";
          else if (errMessage === "402") errorMessage = "Page_Name_Already_Exists";
          else if (errMessage === "401") errorMessage = "Page_Name_Is_Empty";

          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: `${t(errorMessage)}`,
            autoHideDuration: 6000
          });

          console.log("ERROR ON adding new pages ", activeApplication.applicationId);
        });
    }
  }

  function addNewSubForm() {
    const newSubFormJson = { ...newSubForm, projectId: activeApplication.applicationId };
    axios
      .post("/widgets/", newSubFormJson, { withCredentials: true })
      .then((res) => {
        getAllSubForms();
        setCurrentSubform(res.data)
      })
      .catch((err) => {
        const errMessage = err.response.data.error;

        let errorMessage;
        if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
        else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";

        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000
        });

        console.log("ERROR ON adding new pages ", activeApplication.applicationId);
      });
  }

  const setCurrentSubform = (subForm) => {
     resetUndoList();
    resetRedoList();
    setLatestChangesSaved(true);
    setGlobalLoading(true);
    setGlobalLoadingMessage("Loading form...");
    axios
      .get(`widgets/${activeApplication.applicationId}/${subForm.fragmentId}`, { withCredentials: true })
      .then((response) => {
        window.currentWidget = response.data
        setActiveApplication({ ...activeApplication, selectedSubform: response.data });
        //microFrontendData["currentSubform"] = response.data
        if (window?.currentActiveTab) {
          delete window.currentActiveTab;
        }
        setSelectedControl({ elem_type: "" });
        window.selectedControlId_function({ elem_type: "" });
        setActiveMenuId(null);
        
        setPropertyPinned(false);
        var formBuffer = JSON.parse(response.data.fragmentBuffer);
        // addIdsFromJsonToExistingIDs(formBuffer);
        //  console.log(formBuffer);

        const repopulateJson = {
          applicationId: activeApplication.applicationId,
          formId: `${subForm.fragmentId}`,
          formJson: `${response.data.fragmentBuffer}`
        };

        axios.post("/idesign/populateFormStateFromJson", repopulateJson, { withCredentials: true }).then((response) => {
          setGlobalLoadingMessage("Fetching Data objects...");
          fetchDataObject(activeApplication.applicationId, subForm.fragmentId);
        });
        setFormState2(formBuffer);
        setActiveSubForm(response.data);
        setActivePage(null);
        setEventList([]);
        // setShowPagesSubForms(false)
        setCurrentMappedDO([]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function confirmPageChange(e, pageProps, pageType) {
    e.stopPropagation();
    
    if (openCanvasForSubform === "subform") {
      handleSubForm("save");
      if (showSubform) setShowSubForm(false);
    }
    // setPage(page);
    if (eventList >= 1) {
      setNavigateToPageType(pageType);
      setAlertData({
        open: true,
        showConfirm: "showconformationDialogBox",
        alertContentKey: "ChangePageConfirmationContent",
        alertTitleKey: "ChangePageConfirmationTitle",
        Button1Key: "CancelButton",
        Button2Key: "Confirm",
        pageProps: pageProps,
        pageType: pageType,
        setCurrentSubform: setCurrentSubform,
        setCurrentPage: setCurrentPage
        // Id: Id,
      });
    } else {
      if (pageType === "page") {
        setCurrentPage(pageProps);
      } else if (pageType === "subform") {
        setCurrentSubform(pageProps);
      }
    }
  }
  function changePageView() {
    if (navigateToPageType === "page") {
      setCurrentPage(page);
    } else if (navigateToPageType === "subform") {
      setCurrentSubform(page);
    }
  }
  function confirmSubformChange(page) {
    if (openCanvasForSubform === "subform") {
      handleSubForm("save");
      if (showSubform) setShowSubForm(false);
    }
    setPage(page);
    if (!latestChangesSaved) {
      setAlertData({
        open: true,
        showConfirm: "showconformationDialogBox",
        alertContentKey: "ChangePageConfirmationContent",
        alertTitleKey: "ChangePageConfirmationTitle",
        Button1Key: "CancelButton",
        Button2Key: "Confirm"
        // Id: Id,
      });
      // setCurrentPage(page);
    } else {
      setCurrentPage(page);
    }
  }

  const setCurrentPage = (page) => {
    resetUndoList();
    resetRedoList();
    //  console.log("page..", page);
    setLatestChangesSaved(true);
    setGlobalLoading(true);
    axios
      .get(`interfaces/${activeApplication?.applicationId}/${page?.formId}`, { withCredentials: true })
      .then((response) => {
        window.currentInterface = response.data;
        setActiveApplication({ ...activeApplication, selectedPage: response.data });
        // window.currentPageNew1 = {...response.data}
        if (window?.currentActiveTab) {
          delete window.currentActiveTab;
        }
        setIsStep({});
        setSelectedControl({ elem_type: "" });
        window.selectedControlId_function({ elem_type: "" });
        setActiveMenuId(null);

        formState2.isStep = {
          parentStep: 0
        };
        var formBuffer = JSON.parse(response?.data?.formBuffer);
        addIdsFromJsonToExistingIDs(formBuffer);
        //  console.log(formBuffer);

        const repopulateJson = {
          applicationId: activeApplication.applicationId,
          formId: `${page?.formId}`,
          formJson: `${response.data.formBuffer}`
        };

        axios.post("/idesign/populateFormStateFromJson", repopulateJson, { withCredentials: true }).then((response) => {
          //  console.log(response)
          // if(Object.keys(dataObjectsContent).length === 0){
          fetchDataObject(activeApplication.applicationId, page?.formId);
          // }
          setCurrentMappedDO([]);
        });

        // setDefaultPageStyles(formBuffer);
        setFormState2(formBuffer);
        setActivePage(response?.data);
        setActiveSubForm(null);
        setEventList([]);
        setPropertyPinned(false);
        // setShowPagesSubForms(false)
        // collectAllCustomControlId(formBuffer);
        // setDefaultPageStyles(formBuffer);
        // if(formBuffer){
        //     var themeData = formBuffer.theme ;
        //     if( themeData.themeName){

        //     }else {
        //         themeData['themeName'] = "Default Theme" ;
        //     }
        //     setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
        // }
      })
      .catch(function (error) {
        console.log(error);
        setGlobalLoading(false);
      });
  };

  const [showDots, setShowDots] = useState(false);
  const [dots3OpenOf, set3dotsOpen] = useState(false);

  const [showOptions, setShowOptions] = useState(false);
  const [editingPageId, setEditingPageId] = useState("");
  const [newPageName, setNewPageName] = useState("");
  const [deletePageLoader, setDeletePageLoader] = useState(false);
  const [randomCount, setRandomCount] = useState(1);

  function renamePage(page) {
    // const newName=e.target.value;
    //  console.log("called renamePage");
    setEditingPageId(page?.formId);
    setNewPageName(page.formName);

    // const newPage={...activePage, "formName":newName};
  }

  function changeName(e) {
    e.stopPropagation();
    const newName = e.target.value;
    if(/^[a-zA-Z\u0621-\u064A][a-zA-Z0-9\u0621-\u064A\s]*$/u.test(e.target.value) || e.target.value === ""){
      setNewPageName(newName);
    }
  }

  function changeNameDone_page(marvinNewName) {
    setNewPageName("");
    setEditingPageId("");
    const pageIndex = allPages?.findIndex((item) => item.formName === pageNameOld);

    const jsonToSend = {
      activeAppName: microFrontendData?.applicationName,
      pageNameOld: allPages?.[pageIndex]?.formName || pageNameOld || "" ,
      pageNameNew: (newPageName)?.trim() || "" || (marvinNewName)?.trim(),
      type: 2
    };

    let formId = getFormId();
    jsonToSend.formId = allPages?.[pageIndex]?.formId?.toString();
    jsonToSend.appId = activeApplication.applicationId;
    axios
      .post("/idesign/renameObjects", jsonToSend)
      .then(() => {
        window.activityStream("Username has renamed interface " + allPages?.[pageIndex].formName + " to " + newPageName,202,-1,-1,allPages?.[pageIndex]?.formId);
        allPages[pageIndex] = {...allPages[pageIndex], formName: (newPageName)?.trim() || (marvinNewName)?.trim()};
        setAllPages([...allPages]);
        if(allPages?.[pageIndex]?.formId === activePage.formId){
        setActivePage({...allPages[pageIndex],formName: (newPageName)?.trim() || (marvinNewName)?.trim()})
        }
        // const newPage = { ...allPages?.[pageIndex], formName: newPageName|| marvinNewName };
        // axios
        //   .post("/interfaces/", newPage, { withCredentials: true })
        //   .then((res) => {
        //     // setActivePage(res.data);
        //     // getAllPages();
        //     window.activityStream(
        //       "Username has renamed interface " + allPages?.[pageIndex].formName + " to " + newPage.formName,
        //       202,
        //       -1,
        //       -1,
        //       newPage?.formId
        //     );
        //   })
        //   .catch((err) => {
        //     const errMessage = err.response.data.error;
        //     let errorMessage;
        //     if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
        //     else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";
        //     else if (errMessage === "402") errorMessage = "Page_Name_Already_Exists";
        //     else if (errMessage === "401") errorMessage = "Page_Name_Is_Empty";

        //     setAlertData({
        //       open: true,
        //       showConfirm: "showNotification",
        //       alertType: "error",
        //       alertContentMsg: `${t(errorMessage)}`,
        //       autoHideDuration: 6000
        //     });
        //     const jsonToSend2 = {
        //       activeAppName: microFrontendData?.applicationName,
        //       pageNameOld: newPageName || "",
        //       pageNameNew: allPages?.[pageIndex]?.formName || "" || marvinNewName,
        //       type: 2
        //     };
        //     let formId = getFormId();
        //     jsonToSend2.formId = formId.toString();
        //     axios.post("/idesign/renameObjects", jsonToSend2);
        //     console.log("ERROR ON adding new pages ", activeApplication.applicationId);
        //     window.activityStream(
        //       "Username has renamed interface " + allPages?.[pageIndex].formName + " to " + newPage.formName,
        //       202,
        //       -1,
        //       -1,
        //       newPage?.formId
        //     );
        //   });
      })
      .catch((err) => {
        const errMessage = err.response.data.error;
        let errorMessage = "Renaming_Error";
        if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
        else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";
        else if (errMessage === "402") errorMessage = "Page_Name_Already_Exists";
        else if (errMessage === "401") errorMessage = "Page_Name_Is_Empty";
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000
        });

      });
  }

  function changeNameDone_subform(marvinNewName) {
    setNewPageName("");
    setEditingPageId("");
    const pageIndex = allSubForms?.findIndex((item) => item.fragmentName === pageNameOld);

    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showNotification",
      alertType: "info",
      alertContentKey: `${t("SubForm_Page_Reassociation")}`
    });

    const jsonToSend = {
      activeAppName: microFrontendData?.applicationName,
      subPageNameOld: allSubForms?.[pageIndex]?.fragmentName || pageNameOld || "",
      subPageNameNew: (newPageName)?.trim() || "" || (marvinNewName)?.trim(),
      type: 3
    };
    let formId = getFormId();
    jsonToSend.formId = allSubForms?.[pageIndex]?.fragmentId?.toString();
    jsonToSend.appId = activeApplication.applicationId;
    axios
      .post("/idesign/renameObjects", jsonToSend)
      .then(() => {
        window.activityStream("Username has renamed interface " + allSubForms?.[pageIndex]?.fragmentName + " to " + newPageName,202,-1,-1,allSubForms?.[pageIndex]?.fragmentId);
            allSubForms[pageIndex] = {...allSubForms[pageIndex], fragmentName: (newPageName)?.trim() || (marvinNewName)?.trim()};
            setSubForms(allSubForms);
             if(allSubForms?.[pageIndex]?.fragmentId === activeSubForm?.fragmentId){
             setActiveSubForm({...allSubForms[pageIndex],fragmentName: (newPageName)?.trim() || (marvinNewName)?.trim()})
             }
        // const newSubform = { ...allSubForms?.[pageIndex], fragmentName: newPageName|| marvinNewName };
        // axios
        //   .post("/widgets/", newSubform, { withCredentials: true })
        //   .then((res) => {
        //     // setActiveSubForm(res.data);
        //     // getAllSubForms();
        //     window.activityStream(
        //       "Username has renamed interface " + allSubForms?.[pageIndex]?.fragmentName + " to " + newSubform.fragmentName,
        //       202,
        //       -1,
        //       -1,
        //       newSubform.fragmentId
        //     );
        //   })
        //   .catch((err) => {
        //     const errMessage = err.response.data.error;

        //     let errorMessage;
        //     if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
        //     else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";

        //     setAlertData({
        //       open: true,
        //       showConfirm: "showNotification",
        //       alertType: "error",
        //       alertContentMsg: `${t(errorMessage)}`,
        //       autoHideDuration: 6000
        //     });

        //     const jsonToSend2 = {
        //       activeAppName: microFrontendData?.applicationName,
        //       subPageNameOld: newPageName || "",
        //       subPageNameNew: allSubForms?.[pageIndex]?.fragmentName || "" || marvinNewName,
        //       type: 3
        //     };
        //     let formId = getFormId();
        //     jsonToSend2.formId = formId.toString();
        //     axios.post("/idesign/renameObjects", jsonToSend2);

        //     console.log("ERROR ON adding new pages ", activeApplication.applicationId);
        //     window.activityStream(
        //       "Username has renamed interface " + allSubForms?.[pageIndex].fragmentName + " to " + newSubform.fragmentName,
        //       202,
        //       -1,
        //       -1,
        //       newSubform.fragmentId
        //     );
        //   });
      })
      .catch((err) => {
        const errMessage = err.response.data.error;
        let errorMessage = "Renaming_Error";
        if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
        else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";

        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000
        });
      });
  }

  function renameSubform(subform) {
    //  console.log("called renameSubform");
    setEditingPageId(subform.fragmentId);
    setNewPageName(subform.fragmentName);
    setShowOptions(!showOptions);
  }

  function setPageAsHome(page) {
    const activeApplicationNew = {
      ...activeApplication,
      defaultFormId: page?.formId
    };
    setHomePage(page?.formName)
    axios
      .post(`applications/`, activeApplicationNew, { withCredentials: true })
      .then((res) => {
        setActiveApplication(res.data);
        setApplicationData(res.data)
        //  console.log("Application Image Saved");
        getAllPages();
      })
      .catch((err) => {
        console.log("ERROR FOUND in saving page: ", err);
      });
  }

  function copyPage(page) {
    //  console.log("called copyPage", page);

    axios
      .get(`/interfaces/${activeApplication.applicationId}/${page?.formId}`, { withCredentials: true })
      .then((resp) => {
        const duplicatePageJson = {
          ...page,
          formName: `${page.formName}copy${randomCount}`,
          formId: undefined,
          formBuffer: resp.data.formBuffer
        };

        //  console.log("called copyPage", duplicatePageJson);

        axios
          .post("/interfaces/", duplicatePageJson, { withCredentials: true })
          .then((res) => {
            //  console.log("copyPage response ");
            getAllPages();
            setAddNewPageLoader(false);
            window.activityStream(
              "Username has created interface " + res.data.formName,
              201,
              -1,
              activeApplication.applicationId,
              res.data.formId
            );
            setRandomCount((prev) => prev + 1);
            // props.setCurrentPage(res.data);
          })
          .catch((err) => {
            const errMessage = err.response.data.error;
            let errorMessage;
            if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
            else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";
            else if (errMessage === "402") errorMessage = "Page_Name_Already_Exists";
            else if (errMessage === "401") errorMessage = "Page_Name_Is_Empty";

            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: `${t(errorMessage)}`,
              autoHideDuration: 6000
            });
            console.log("ERROR ON copyPage ", activeApplication.applicationId);
            setAddNewPageLoader(false);
          });
      })
      .catch((error) => {});
  }

  function copySubform(subform) {
    //  console.log("called copySubform", subform);

    axios
      .get(`/widgets/${activeApplication.applicationId}/${subform.fragmentId}`, { withCredentials: true })
      .then((resp) => {
        const duplicateSubformJson = {
          ...subform,
          fragmentName: `${subform.fragmentName}copy${randomCount}`,
          fragmentId: undefined,
          fragmentBuffer: resp.data.fragmentBuffer
        };

        //  console.log("called copySubform", duplicateSubformJson);

        axios
          .post("/widgets/", duplicateSubformJson, { withCredentials: true })
          .then((res) => {
            //  console.log("copySubform response ");
            getAllSubForms();
            setAddNewPageLoader(false);
            window.activityStream(
              "Username has created interface " + res.data.formName,
              201,
              -1,
              activeApplication.applicationId,
              res.data?.formId
            );
            setRandomCount((prev) => prev + 1);
            // props.setCurrentPage(res.data);
          })
          .catch((err) => {
            const errMessage = err.response.data.error;

            let errorMessage;
            if (errMessage === "502") errorMessage = "Widget_Name_Already_Exists";
            else if (errMessage === "501") errorMessage = "Widget_Name_Is_Empty";

            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: `${t(errorMessage)}`,
              autoHideDuration: 6000
            });

            console.log("ERROR ON copySubform ", activeApplication.applicationId);
            setAddNewPageLoader(false);
          });
      })
      .catch((error) => {});
  }

  function deleteConfirmation(page, e, isPage) {
    e.stopPropagation();

    setAlertData({
      open: true,
      showConfirm: "showconformationDialogBox",
      alertContentKey: isPage ? "PageDeleteConfirmationContent" : "SubFormDeleteConfirmationContent",
      alertTitleKey: isPage ? "PageDeleteConfirmationTitle" : "SubFormDeleteConfirmationTitle",
      Button1Key: "No",
      Button2Key: "Yes",
      deleteCB: isPage ? deletePage : deleteSubform,
      pageToDelete: page,
    });
  }

  function deletePage(page) {
    //  console.log("delete Page called",page);
    setDeletePageLoader(true);
    axios
      .post(
        `interfaces/${page.existingFormId}/${page?.formId}`,
        { existingFormId: page.existingFormId, formId: page?.formId },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.status === 200) {
          getAllPages();
          setDeletePageLoader(false);

          const updatedPageList = filteredPages.filter((item) => item.formId !== page.formId);

          const homePage = updatedPageList.filter((page) => page?.formId === activeApplication?.defaultFormId);
          const currentPage = homePage.length ? homePage[0] : {};

          setCurrentPage(currentPage);
          //  console.log("Page deleted");
        }
        window.activityStream(
          "Username has deleted interface " + page.formName,
          203,
          -1,
          page.existingFormId,
          page?.formId
        );
      })
      .catch((err) => {
        getAllPages();
        setDeletePageLoader(false);
        console.log("WHILE DELETING Page ERR:", err);
        window.activityStream(
          "Username has deleted interface " + page.formName,
          203,
          -1,
          page.existingFormId,
          page?.formId
        );
      });
  }

  function deleteSubform(subForm) {
    //  console.log("delete Subform called",subForm);
    axios
      .post(
        `widgets/${subForm.projectId}/${subForm.fragmentId}`,
        { projectId: subForm.projectId, fragmentId: subForm.fragmentId },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.status === 200) {
          getAllSubForms();
          const updatedSubFormsList = filteredSubforms.filter((item) => item.fragmentId !== subForm.fragmentId);

          if (updatedSubFormsList.length) {
            setCurrentSubform(updatedSubFormsList[0]);
          } else {
            const homePage = filteredPages.filter((page) => page?.formId === activeApplication?.defaultFormId);
            setCurrentPage(homePage.length ? homePage[0] : {});
          }
        }
      })
      .catch((err) => {
        getAllSubForms();
        console.log("WHILE DELETING Subform ERR:", err);
      });
  }

  function openPreviewPage(page) {
    saveFormState();
    const data = { ...activeApplication, page: { ...page } };
    window.OpenSelectedPagePreview(data);
  }

  function openPreviewWidget(subform) {
    saveFormState();
    const data = { ...activeApplication, subform: { ...subform } };
    window.OpenSelectedPagePreview(data);
  }

  const subFormOptionsArray = [
    {
      title: "Preview",
      action: openPreviewWidget,
      icon: Preview
    },
    {
      title: "Rename",
      action: renameSubform,
      icon: Rename
    },
    // {
    //     title:"Set As Home",
    //     action:setPageAsHome,
    //     icon:Home
    // },
    {
      title: "Duplicate",
      action: copySubform,
      icon: Duplicate
    },
    {
      title: "Delete",
      action: deleteConfirmation,
      icon: Delete
    }
  ];

  const pageOptionsArray = [
    {
      title: "Preview",
      action: openPreviewPage,
      icon: Preview
    },
    {
      title: "Rename",
      action: renamePage,
      icon: Rename
    },
    {
      title: "Set As Home",
      action: setPageAsHome,
      icon: Home
    },
    {
      title: "Duplicate",
      action: copyPage,
      icon: Duplicate
    },
    {
      title: "Delete",
      action: deleteConfirmation,
      icon: Delete
    }
  ];

  const [activePopUp, setActivePopUp] = useState();
  const [active3dots_PopUp, setactive3dots_PopUp] = useState();
  const [popUpGoingOut, setpopUpGoingOut] = useState(false);

  useEffect(() => {
    setactive3dots_PopUp(document.querySelector(`#popUp3dots_${showDots}_pages`)?.getBoundingClientRect()?.top);
    setActivePopUp(document.querySelector(`#popUp_${showDots}_pages`)?.getBoundingClientRect()?.top);
    if (
      document.documentElement?.getBoundingClientRect()?.bottom <
      document.querySelector(`#popUp_${showDots}_pages`)?.getBoundingClientRect()?.bottom
    ) {
      setpopUpGoingOut(true);
    } else {
      setpopUpGoingOut(false);
    }
  }, [showOptions, showDots]);

  const dropDownPage = (page) => (
    <div onClick={(e) => { e.stopPropagation(); }} id={`popUp3dots_${page?.formId}_pages`} style={{ position: "relative" }}>
      <img
        src={threedots_x_SVG}
        style={{ height: "18px" }}
        onClick={(e) => {
          e.stopPropagation();
          setShowOptions(!showOptions);
        }}
        alt="More Icon"
      />

      {showOptions === true && (
        <div id={`popUp_${page?.formId}_pages`} className={classes.popUp}>
          <div
            style={
              translationStyles1
                ? {
                    position: "absolute",
                    left: "120px",
                    top: `${active3dots_PopUp - activePopUp + 20}px`,
                    width: "120px",
                    border: "1px solid #fff",
                    boxShadow: "0px 3px 6px #00000029"
                  }
                : {
                    position: "absolute",
                    right: "120px",
                    top: `${active3dots_PopUp - activePopUp + 20}px`,
                    width: "120px",
                    border: "1px solid #fff",
                    boxShadow: "0px 3px 6px #00000029"
                  }
            }
          >
            {pageOptionsArray.map((item) => {
              return (
                <>
                  {((page?.formId === activeApplication?.defaultFormId &&
                    item.title !== "Delete" &&
                    item.title !== "Set As Home") ||
                    page?.formId !== activeApplication?.defaultFormId) && (
                    <span onClick={(e) => item.action(page, e, true)} key={item.title}>
                      <img src={item.icon} alt="Action Icon" />
                      {t(item.title)}
                    </span>
                  )}
                </>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );

  const dropDownSubform = (subForm) => (
    <div onClick={(e) => { e.stopPropagation(); }} id={`popUp3dots_${subForm?.fragmentId}_pages`} style={{ position: "relative" }}>
      <img
        src={threedots_x_SVG}
        style={{ height: "18px" }}
        onClick={(e) => {
          e.stopPropagation();
          setShowOptions(!showOptions);
        }}
        alt="More Icon"
      />

      {showOptions === true && (
        <div id={`popUp_${subForm?.fragmentId}_pages`} className={classes.popUp}>
          <div
            style={
              translationStyles1
                ? {
                    position: "absolute",
                    left: "120px",
                    top: `${active3dots_PopUp - activePopUp + 20 - 120}px`,
                    width: "120px",
                    border: "1px solid #fff",
                    boxShadow: "0px 3px 6px #00000029"
                  }
                : {
                    position: "absolute",
                    right: "120px",
                    top: `${active3dots_PopUp - activePopUp + 20 - 120}px`,
                    width: "120px",
                    border: "1px solid #fff",
                    boxShadow: "0px 3px 6px #00000029"
                  }
            }
          >
            {subFormOptionsArray.map((item) => {
              return (
                <span onClick={(e) => item.action(subForm, e, false)} key={item.title}>
                  <img src={item.icon} alt="Subform Icon" /> {t(item.title)}{" "}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );

  const loaderHTML = (
    <>
      {deletePageLoader ? (
        <>
          <span>
            Deleting &nbsp; <CircularProgress size={18} />
          </span>
        </>
      ) : (
        <></>
      )}
    </>
  );

  const loaderHTMLForAdd = (
    <>
      {addNewPageLoader ? (
        <>
          <span>
            Loading &nbsp; <CircularProgress size={18} />
          </span>
        </>
      ) : (
        <></>
      )}
    </>
  );

  const onSideBarSearch = (obj) => {
    let searchedValPages = allPages.filter((val) => {
      return val?.["formName"].toLowerCase().includes(obj.searchString?.toLowerCase());
    });

    setFilteredPages(searchedValPages);

    let searchedValSubforms = allSubForms.filter((val) => {
      return val?.["fragmentName"].toLowerCase().includes(obj.searchString?.toLowerCase());
    });

    setFilteredSubforms(searchedValSubforms);
  };

  const onSideBarSearchClear = () => {
    setFilteredPages(allPages);
    setFilteredSubforms(allSubForms);
  };
  useEffect(()=>{
    if(renamePageSubform?.pageRename){
     changeNameDone_page(renamePageSubform?.NewName)
    }
    else if(renamePageSubform?.subformRename){
     changeNameDone_subform(renamePageSubform?.NewName)
    }
   },[renamePageSubform])
   
  useEffect(() => {
    setFilteredPages(allPages);
  }, [allPages]);

  useEffect(() => {
    setFilteredSubforms(allSubForms);
  }, [allSubForms]);

  const removeShowDots = () => {
    setShowOptions(false);
    setShowDots("");
  };

  return (
    <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={(e) => handleClickAway(e)}>
      <div>
        <div
          className={`${classes.main} pagessubforms_main`}
          style={translationStyles1 ? { left: "unset", right: "-68px" } : null}
        >
          {/* <div className={classes.mainHeader}>
                <span> {activeApplication?.applicationName} </span>
                <span onClick={()=>setShowPagesSubForms(false)}> <Cross/> </span>
            </div> */}

          {/* <SearchControl width={'288px'} collapsedWidth={'0px'}  />  */}
          <div className={classes.search}>
            <SearchBox
              height="14px"
              width="100%"
              direction={translationStyles1 ? "rtl" : "ltr"}
              onSearchSubmit={onSideBarSearch}
              clearSearchResult={onSideBarSearchClear}
              placeholder={t("Search Page/Subforms")}
              regex={""}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", height: "94%" }}>
            {/************************************ PAGES start *******************************************/}
            <div style={{ flex: "1", height: "50%" }}>
              <div className={`${classes.header} pagessubforms_header`}>
                <span>
                  {" "}
                  {t("PAGES")} ({allPages.length})
                </span>
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`}
                  classes={{ root: classes.btn1, label: classes.btnlabel }}
                  size="small"
                  variant="outlined"
                  onClick={openCreatePageTemplate}
                >
                  {" "}
                  {t("Create Page")}{" "}
                </Button>
                {/* <Button  className={ addNewPageLoader ? classes.plusButtonDisabled :  classes.plusButton}>Create Page</Button> */}
              </div>
              <div className={`${classes.allPages} pagessubforms_body`}>
                {filteredPages.map((page) => {
                  return (
                    <>
                      <span
                        onClick={(e) => {
                          confirmPageChange(e,page, "page");
                        }}
                        className={page?.formId === activePage?.formId ? classes.activePage : classes.pages}
                        onMouseEnter={() => {
                          setShowDots(page?.formId);
                          set3dotsOpen("page");
                        }}
                        onMouseLeave={() => removeShowDots()}
                      >
                        {editingPageId === page?.formId && dots3OpenOf === "page" ? (
                          <input
                            aria-label={"Page Name"}
                            onClick={(e)=>{e.stopPropagation()}}
                            onChange={changeName}
                            onBlur={changeNameDone_page}
                            value={newPageName}
                            defaultValue={newPageName}
                            onFocus={(e)=>{setPageNameOld(e.target.value)}}
                          />
                        ) : (
                          <span className={classes.fonts}> {page.formName} </span>
                        )}
                        {showDots === page?.formId && <span> {loaderHTML} </span>}
                        {showDots !== page?.formId && page?.formId === activeApplication?.defaultFormId && (
                          <img src={home_blue} alt="Home Icon" />
                        )}
                        {showDots === page?.formId && dots3OpenOf === "page" && dropDownPage(page)}
                      </span>
                    </>
                  );
                })}
                <div style={{ marginLeft: "15px" }}>
                  <span> {loaderHTMLForAdd} </span>
                </div>
              </div>
            </div>

            {/************************************ PAGES end *******************************************/}

            {/************************************ SUB-FORMS start *******************************************/}
            <div style={{ flex: "1", height: "50%" }}>
              <div className={classes.header}>
                <span>
                  {" "}
                  {t("SUBFORMS")} ({allSubForms.length})
                </span>
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`}
                  classes={{ root: classes.btn2, label: classes.btnlabel }}
                  size="small"
                  variant="outlined"
                  onClick={openCreateSubformTemplate}
                >
                  {" "}
                  {t("Create Subform")}{" "}
                </Button>
              </div>
              <div className={classes.allPages}>
                {filteredSubforms.map((subForm) => {
                  return (
                    <>
                      <span
                        onClick={(e) => {
                          confirmPageChange(e,subForm, "subform");
                        }}
                        className={
                          subForm?.fragmentId === activeSubForm?.fragmentId ? classes.activePage : classes.pages
                        }
                        onMouseEnter={() => {
                          setShowDots(subForm.fragmentId);
                          set3dotsOpen("subform");
                        }}
                        onMouseLeave={() => setShowDots("")}
                        // onDrag={onDragOfSubform}
                        // onDragStart={onDragStartOfSubform}
                        // draggable="true"
                        // onTouchStart={(e) => {
                        //  e.currentTarget.draggable = false;
                        //  }}
                        // onTouchEnd={(e) => {
                        //  e.currentTarget.draggable = true;
                        //  }}
                        subformId={subForm.fragmentId}
                      >
                        {/* <div onClick={(e)=>{e.stopPropagation();}}> */}
                          {editingPageId === subForm.fragmentId && dots3OpenOf === "subform" ? (
                          <input
                            aria-label={"Fragment Name"}
                            onClick={(e)=>{e.stopPropagation()}}
                            onChange={changeName}
                            onBlur={changeNameDone_subform}
                            value={newPageName}
                            defaultValue={newPageName}
                            onFocus={(e)=>{setPageNameOld(e.target.value)}}
                          />
                          ) : (
                            // <span className={classes.fonts}> {subForm.fragmentName} </span>
                            <SubformTooltip text={subForm.fragmentName} classes={classes} />
                          )}
                          {showDots === subForm.fragmentId && dots3OpenOf === "subform" && dropDownSubform(subForm)}
                        {/* </div> */}
                      </span>
                    </>
                  );
                })}
              </div>
            </div>
            {/************************************ SUB-FORMS end *******************************************/}
          </div>
        </div>
        {pageTemplateOpen && (
          <CreatePageTemplate
            setCurrentSubform={setCurrentSubform}
            open={true}
            handleClose={handleClose}
            setPageAsHome={setPageAsHome}
            setCurrentPage={setCurrentPage}
            allPagesCount={allPages.length}
            defaultBuffer={defaultBuffer}
            addNewPageLoader={addNewPageLoader}
            setAddNewPageLoader={setAddNewPageLoader}
            activeApplication={activeApplication}
            getAllPages={() => getAllPages("page")}
            componentFor={"page"}
          />
        )}
        {subformTemplateOpen && (
          <CreatePageTemplate
            open={true}
            handleClose={handleSubformClose}
            setCurrentSubform={setCurrentSubform}
            setPageAsHome={setPageAsHome}
            setCurrentPage={setCurrentPage}
            allPagesCount={allPages.length}
            defaultBuffer={defaultBuffer}
            addNewPageLoader={addNewPageLoader}
            setAddNewPageLoader={setAddNewPageLoader}
            activeApplication={activeApplication}
            getAllPages={() => getAllPages("subform")}
            componentFor={"subform"}
          />
        )}
        {
              alertData.open === true &&
            <CustomizedAlert alertData={alertData} handleFunction={() => changePageView()}/>
            }
      </div>
    </ClickAwayListener>
  );
}

export default PagesSubForms;
